import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createSession = async (email) => {
  const res = await api.post("/auth/session", { email });
  return res.data;
};

export const sendChatMessage = async (sessionId, message) => {
  const res = await api.post(`/chat/${sessionId}`, { message });
  return res.data;
};

export const getChatHistory = async (sessionId) => {
  const res = await api.get(`/chat/${sessionId}/history`);
  return res.data;
};

export const submitOrder = async (formData) => {
  const res = await api.post(`/orders`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const emailMeThisQuote = async ({ sessionId, quote, recipientEmail, variant }) => {
  const res = await api.post(`/quote/email`, {
    session_id: sessionId,
    quote,
    recipient_email: recipientEmail || null,
    variant: variant || "full",
  });
  return res.data;
};

export const checkDomainPolicy = async (email) => {
  const res = await api.get(`/auth/domain-policy`, { params: { email } });
  return res.data;
};

export const submitAccessRequest = async ({ email, full_name, company, use_case }) => {
  const res = await api.post(`/auth/access-request`, {
    email,
    full_name,
    company: company || null,
    use_case: use_case || null,
  });
  return res.data;
};

export const requoteMulti = async ({ sessionId, items, summary, editedIndex }) => {
  const res = await api.post(`/chat/${sessionId}/requote`, {
    items,
    summary: summary || null,
    edited_index: editedIndex ?? null,
  });
  return res.data;
};

export const getSessionSavings = async (sessionId) => {
  const res = await api.get(`/sessions/${sessionId}/savings`);
  return res.data;
};

export const getProducts = async () => {
  const res = await api.get(`/products`);
  return res.data;
};

export const getPapers = async () => {
  const res = await api.get(`/papers`);
  return res.data;
};

export const getQuoteMatrix = async ({ sessionId, productId, sizeId, paperIds, quantities, finishIds, pages }) => {
  const res = await api.post(`/quote/matrix${sessionId ? `?session_id=${sessionId}` : ""}`, {
    product_id: productId,
    size_id: sizeId || null,
    paper_ids: paperIds || null,
    quantities: quantities || null,
    finish_ids: finishIds || null,
    pages: pages || null,
  });
  return res.data;
};
